module.exports = __webpack_public_path__ + "media/images/partner/media/ntv-9093228943eff0cdefae903bfcb8f2ba.png";